import script from "./settingsEditor.vue?vue&type=script&lang=js"
export * from "./settingsEditor.vue?vue&type=script&lang=js"

import "./settingsEditor.vue?vue&type=style&index=0&id=129a4508&lang=css"

const __exports__ = script;

export default __exports__